import { useCallback } from 'react'
import { todayIn } from '@trackmind/core'
import { useApp } from '@/context/AppContext'

/**
 * What day it is, for this user.
 *
 * Every screen used to call `toISODateString(new Date())` directly, which is
 * the device's clock. That was right — the app runs on their machine — but it
 * meant "today" had twelve definitions and none of them could be told
 * otherwise. When the MCP server needed the same answer from somewhere else,
 * there was nothing to ask.
 *
 * Now there is one definition (`todayIn` in core) and one setting
 * (`preferences.timezone`), and the app and the assistant read the same pair.
 * With the zone unset or matching the device, this behaves exactly as before.
 *
 * Returns a function rather than a value: a component that renders across
 * midnight should get the new date on its next render, not the one captured
 * when it mounted.
 */
export function useToday(): () => string {
  const { preferences } = useApp()
  const zone = preferences?.timezone
  return useCallback(() => todayIn(zone), [zone])
}
